<template>
  <el-dialog :title="dialogName" :visible.sync="dialogVisible" width="1300px" :close-on-click-modal="false">
    <div class="main-box main-content" style="height: 600px;">
      <xr-table ref="xrTable" :configure="configure"></xr-table>
    </div>
    <!-- 详情页 -->
    <archive-info ref="archiveInfo" v-if="isArchiveInfoShow" ></archive-info>
  </el-dialog>
</template>

<script>
import { getTodayDate} from '../../../utils/common/DateUtils.js'
import ArchiveInfo from "../archive/archive-info.vue";

export default {
  name: "archiveSelectDialog",
  props: ['type'],
  data() {
    return {
      dialogName: '居民选择',
      dialogVisible: false,                                        //弹框
      isArchiveInfoShow: false,                                   //
      teamId: '',
      teamName: '',
      examineType_list: [],
      configure: {
        url: '/web/service?method=tPhPatientInfo_patientSelectList',
        listParam:{
          isViewFull: ''
        },
        isShowSearch: true,
        isSelectFirst: false,
        pagination: true,
        defaultNoLoadData: true,
        idField: 'archiveId',
        tableHeight: 500,
        columns: [
          {
            field: 'radio',
            width: 60,
          },
          {
            field: 'zoneName',
            title: '居委会',
            width: 100,
            condition: {
              searchType: 'input',
              searchName: 'zoneNameSearch',
              value:''
            },
          },
          {
            field: 'sickName',
            title: '姓名',
            width: 70,
            condition: {
              searchType: 'input',
              searchName: 'sickNameSearch',
              value: ''
            },
            that: this,
            cellType: 'click',
            formatter: function(value){
              return '<a class="info-a">' + value +  '</a>';
            },
            handler: function (row) {
              this.that.viewArchiveInfo(row);
            }
          },
          {
            field: 'identityCardNo',
            title: '身份证号',
            width: 170,
            condition: {
              searchType: 'input',
              searchName: 'identityCardNoSearch',
              value: ''
            },
          },
          {
            field: 'sickSex',
            title: '性别',
            width: 70,
            align: 'center',
            condition: {
              searchType: 'select',
              searchName: 'sickSexSearch',
              value:'',
              selectList: [
                {value: '', label: ''},
                {value: '1', label: '男'},
                {value: '2', label: '女'}
              ]
            },
          },
          {
            field: 'sickAge',
            title: '年龄',
            width: 70,
            align: 'center',
            condition: {
              searchType: 'input',
              searchName: 'sickAgeSearch',
              value:''
            },
          },

          {
            field: 'manageTeamName',
            title: '管理团队',
            width: 120,
            condition: {
              searchType: 'input',
              searchName: 'teamNameSearch',
              value:''
            },
          },
          {
            field: 'manageStaffName',
            title: '家庭医生',
            align: 'center',
            width: 90,
            condition: {
              searchType: 'input',
              searchName: 'manageStaffNameSearch',
              value:''
            },
          },
          {
            field: 'problemBloodFlag',
            title: '高血压',
            width: 70,
            align: 'center',
            condition: {
              searchType: 'select',
              searchName: 'problemBloodFlag',
              value: '',
              selectList:[
                {value: '',label: ''},
                {value: '0',label: '否'},
                {value: '1',label: '是'},
              ],
            },
          },
          {
            field: 'problemGlucoseFlag',
            title: '糖尿病',
            width: 70,
            align: 'center',
            condition: {
              searchType: 'select',
              searchName: 'problemGlucoseFlag',
              value: '',
              selectList:[
                {value: '',label: ''},
                {value: '0',label: '否'},
                {value: '1',label: '是'},
              ],
            },
          },
          {
            field: 'sickAddress',
            title: '地址',
            condition: {
              searchType: 'input',
              searchName: 'sickAddressSearch',
              value:''
            },
          }
        ],
        toolbar: [
          {
            text: '确认',
            iconCls: 'wk wk-list2',
            that: this,
            handler: function () {
              this.that.getSelectedValue();
            }
          },
          {
            text: '取消',
            iconCls: 'wk wk-danger wk-cancel2',
            that: this,
            handler: function () {
              this.that.handleCloseDialog();
            }
          },
          {
            text: '根据身份证号更新居民信息',
            iconCls: 'wk wk-success wk-down',
            that: this,
            handler: function () {
              this.that.handleUpdateArchiveInfo();
            }
          },{
            toolType: 'checkAll',
            text: '全部',
            iconCls: 'wk wk-edit',
            that: this,
            handler: function (value) {
              this.that.isViewAll(value)
            }
          }
        ]
      },

    }
  },
  components: {
    ArchiveInfo
  },
  methods: {
    init(){
      this.dialogVisible = true;
      this.$nextTick(()=>{
        this.$refs.xrTable.getData();
      })
    },
    //显示全部
    isViewAll(value){
      this.configure.listParam['isViewFull'] = value;
      this.$nextTick(()=>{
        this.$refs.xrTable.getData();
      })
    },
    //查询档案信息
    viewArchiveInfo(row){
      this.isArchiveInfoShow = true;
      this.$nextTick(()=>{
        this.$refs.archiveInfo.init(row.archiveId) //初始化页面
      })
    },
    //根据身份证号更新居民信息
    handleUpdateArchiveInfo(){
      this.$prompt('请输入要更新的身份证号', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        return this.request({
          method:'post',
          url:'/web/service',
          params:{
            'method':'tPhPatientInfo_updateArchiveInfoByCardNo',
            'identityCardNo': value
          }
        }).then((response) =>{
          if (response.code === 0) {
            this.$message({
              message: '更新成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.configure.columns[4].condition.value = value;
                this.$nextTick(()=>{
                  this.$refs.xrTable.submit();
                })
              }
            })
          } else {
            this.$message.error(response.msg)
          }
        }).catch(() => {});
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },
    getSelectedValue(){
      let row = this.$refs.xrTable.radio_row;
      if(row == null || row.archiveId == null || row.archiveId == '' || row.archiveId == undefined){
        this.$message.warning('请选择一条数据！');
        return false;
      }
      this.dialogVisible = false;
      this.$emit('archiveSelectCallback', row);
    },
    //关闭弹窗框
    handleCloseDialog(){
      this.dialogVisible = false;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/ph/common/archive-select-dialog.vue